import {CustomWiggle} from "gsap/dist/CustomWiggle";
import {SymbolValues} from "../server/NineToFiveData";
import {OldEmitterConfig} from "pixi-particles";

/**
 * Created by jonas on 2022-06-10.
 */

export class NineToFiveStatics {
    static DEFAULT_SYMBOL_SIZES:number[][] = [
        [1,1,1],
        [1,1,1,1],
        [1,1,1],
        [1,1,1,1],
        [1,1,1],
        [1,1,1,1],

    ];
    public static DEFAULT_NUMBER_OF_WAYS:number = 5184;

    public static isLowSymbol(value:string):boolean {
        return NineToFiveStatics.LOW_SYMBOLS.indexOf(value) >= 0;
    }

    public static isScatterSymbol(value:string):boolean {
        return NineToFiveStatics.SCATTER_SYMBOLS.indexOf(value) >= 0;
    }

    public static LOW_SYMBOLS:string[] = ["L1", "L2", "L3", "L4"];
    public static MID_SYMBOLS:string[] = ["M1", "M2", "M3", "M4"];
    public static HIG_SYMBOLS:string[] = ["W", "S1", "S2"];
    public static SCATTER_SYMBOLS:string[] = ["S1", "S2"];

    public static SYMBOL_SPRITE_WIDTH:number = 144;
    public static SYMBOL_SPRITE_HEIGHT:number = 148;

    public static SYMBOL_WIDTH:number = 144;
    public static SYMBOL_HEIGHT:number = 148;

    public static REEL_X_OFFSET:number = NineToFiveStatics.SYMBOL_WIDTH;
    public static REEL_Y_OFFSET:number = NineToFiveStatics.SYMBOL_HEIGHT;

    public static STEP_WIDTH:number = NineToFiveStatics.SYMBOL_WIDTH * 0.5;
    public static STEP_HEIGHT:number = NineToFiveStatics.SYMBOL_HEIGHT * 0.5;


    public static REEL_AREA_X_OFFSET:number = 114;
    public static REEL_AREA_Y_OFFSET:number = 114;




    static stepDuration:number = 0.08;
    public static SYMBOL_WIDTH_FS:number = 164;
    public static SYMBOL_HEIGHT_FS:number = 164;

    public static REEL_X_OFFSET_FS:number = NineToFiveStatics.SYMBOL_WIDTH * 0.5;
    public static REEL_Y_OFFSET_FS:number = NineToFiveStatics.SYMBOL_HEIGHT;

    public static freespinStepSize:{x:number, y:number} = {
        x: 0,
        y: NineToFiveStatics.SYMBOL_HEIGHT_FS *1,
    }

    public static REEL_AREA_X_OFFSET_FREESPIN:number = 32;
    public static REEL_AREA_Y_OFFSET_FREESPIN:number = NineToFiveStatics.SYMBOL_HEIGHT * 0.5 + 74;

    public static TIME_SCALE = 1;


    public static SYMBOL_DROP_DELAY = 0.1;
    public static SYMBOL_DROP_FAST_SPIN_DELAY = 0.04;

    public static FS_SYMBOL_DROP_DELAY = 0.2;
    public static FS_SYMBOL_DROP_FAST_SPIN_DELAY = 0.1;

    public static DROP_OUT_DURATION = 0.4;
    public static DROP_IN_DURATION:number = 0.4;
    public static COLLAPSE_DURATION:number = 0.15;
    public static COLLAPSE_DELAY:number = 0.02;

    public static FILL_UP_DROP_DURATION:number = 0.05;
    public static FILL_UP_ROW_DELAY:number = 0.05;
    public static FILL_UP_SYMBOL_DELAY:number = 0.05;
    public static FILL_UP_SYMBOL_NEAR_WIN_DELAY:number = 0.33;


    static WIN_SYMBOL_DELAY:number = 0.05;
    static LOCK_DELAY:number = 0.1;


    public static SYMBOL_WIN_DELAY:number = 0.05;

    public static LAST_POSITIONS_IN_R2L_ROW:number[][] = [
        [0, 1, 2],
        [-1, -1, -1, 3],
        [-1, -1, -1],
        [-1, -1, -1, 4],
        [-1, -1, -1],
        [-1, -1, -1, 5]
    ]

    public static bigWinAnticipationWiggle = CustomWiggle.create("bigWinAnticipationWiggle", {
        wiggles : 60,
        amplitudeEase : "none",
        timingEase : "none",
    });

    public static explodeWiggle = CustomWiggle.create("explodeWiggle", {
        wiggles : 20,
        amplitudeEase : "none",
        timingEase : "none",
    });

    public static defaultSymbolValues:SymbolValues = {
        "L1": {3: 6, 4: 10, 5: 16, 6: 30, 7: 40, 8: 50, 9: 60},
        "L2": {3: 6, 4: 10, 5: 14, 6: 25, 7: 40, 8: 50, 9: 60},
        "L3": {3: 5, 4: 8, 5: 12, 6: 25, 7: 30, 8: 40, 9: 50},
        "L4": {3: 5, 4: 8, 5: 12, 6: 20, 7: 30, 8: 40, 9: 50},
        "L5": {3: 5, 4: 8, 5: 12, 6: 20, 7: 30, 8: 40, 9: 50},
        "M1": {3: 20, 4: 30, 5: 40, 6: 50, 7: 60, 8: 70, 9: 80},
        "M2": {3: 15, 4: 20, 5: 30, 6: 40, 7: 50, 8: 60, 9: 70},
        "M3": {3: 12, 4: 20, 5: 30, 6: 40, 7: 50, 8: 60, 9: 70},
        "M4": {3: 12, 4: 15, 5: 20, 6: 35, 7: 45, 8: 55, 9: 65},
        "M5": { 3: 10, 4: 15, 5: 20, 6: 35, 7: 45, 8: 55, 9: 65},
    };

    public static defaultParticleConfig:OldEmitterConfig = {
        "alpha": {
            "start": 1,
            "end": 1
        },
        "scale": {
            "start": 0.1,
            "end": 0.02,
            "minimumScaleMultiplier": 1
        },
        "color": {
            "start": "#fffab8",
            "end": "#ff7300"
        },
        "speed": {
            "start": 100,
            "end": 0,
            "minimumSpeedMultiplier": 1
        },
        "acceleration": {
            "x": 0,
            "y": 750
        },
        "maxSpeed": 0,
        "startRotation": {
            "min": 0,
            "max": 360
        },
        "noRotation": true,
        "rotationSpeed": {
            "min": 0,
            "max": 0
        },
        "lifetime": {
            "min": 0.4,
            "max": 1.0
        },
        "blendMode": "normal",
        "frequency": 0.001,
        "emitterLifetime": -1,
        "maxParticles": 500,
        "pos": {
            "x": 0,
            "y": 0
        },
        "addAtBack": false,
        "spawnType": "circle",
        "spawnCircle": {
            "x": 0,
            "y": 0,
            "r": 20
        }
    };


    constructor() {

    }


}